import React from 'react';
import { APP_VERSION } from '../version';
import { FiArchive, FiSun, FiMoon, FiLogOut, FiUser, FiSettings } from 'react-icons/fi';

const TopHeader = ({
  customerName,
  username,
  ocrStatus,
  theme,
  onToggleTheme,
  onLogout,
  onOpenCabinets,
  onOpenSettings
}) => {
  const titleText = customerName || import.meta.env.VITE_COMPANY_NAME || 'TrueView Docs';
  const companyWeb = String(
    import.meta.env.VITE_COMPANY_WEB ||
    import.meta.env.COMPANY_WEB ||
    ''
  ).trim();
  const companyPhone = String(
    import.meta.env.VITE_COMPANY_PHONE ||
    import.meta.env.COMPANY_PHONE ||
    ''
  ).trim();
  const contactItems = [
    companyWeb
      ? {
          key: 'web',
          node: (
            <a
              href={companyWeb}
              target="_blank"
              rel="noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              {companyWeb.replace(/^https?:\/\//i, '')}
            </a>
          ),
        }
      : null,
    companyPhone ? { key: 'phone', node: <span>{companyPhone}</span> } : null,
  ].filter(Boolean);
  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '60px',
      backgroundColor: 'var(--card-bg)',
      color: 'var(--text)',
      padding: '0 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxSizing: 'border-box',
      zIndex: 1000,
      borderBottom: '1px solid var(--border)',
    }}>
      {/* Left: Logo + OCR status */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.1 }}>
          {(() => {
            const baseUrl = (import.meta.env.BASE_URL || '/');
            const logoName = (import.meta.env.COMPANY_LOGO || 'company_logo2.png');
            const logoUrl = `${String(baseUrl).replace(/\/+$/, '/')}${String(logoName).replace(/^\/+/, '')}`;
            return (
              <img
                src={logoUrl}
                alt="Company"
                style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
              />
            );
          })()}
          {(APP_VERSION || contactItems.length > 0) && (
            <div
              style={{
                fontSize: 11,
                color: 'var(--text-soft)',
                marginTop: 2,
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              {APP_VERSION && <span>v{APP_VERSION}</span>}
              {contactItems.map((item) => (
                <span key={item.key} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <span aria-hidden="true">•</span>
                  {item.node}
                </span>
              ))}
            </div>
          )}
        </div>
        {ocrStatus?.active && ocrStatus?.total > 0 && (
          <div style={{
            padding: '4px 10px',
            backgroundColor: '#e3f2fd',
            color: '#1565c0',
            borderRadius: 12,
            fontSize: 12,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            border: '1px solid #bbdefb'
          }}>
            <span className="spinner-small" style={{
              width: 10, height: 10, borderRadius: '50%',
              border: '2px solid #1565c0', borderTopColor: 'transparent',
              display: 'inline-block', animation: 'spin 1s linear infinite'
            }}/>
            <span>{(() => {
              const total = ocrStatus.total || 0;
              const processed = ocrStatus.processed || 0;
              const currentIndex = Math.min(total, processed + 1);
              return `OCR'ng ${currentIndex}/${total}`;
            })()}</span>
          </div>
        )}
      </div>

      {/* Center: Company name */}
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 24,
      }}>
        <span style={{ fontSize: 20, fontWeight: 'bold', color: 'var(--primary)' }}>{titleText}</span>
      </div>

      {/* Right: Theme toggle + Username */}
      <div style={{ display: 'flex', alignItems: 'center', color: 'var(--text)', gap: 12 }}>
        <button
          onClick={onOpenCabinets}
          title="Cabinets"
          className="btn-ghost"
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <FiArchive aria-hidden /> Cabinets
          </span>
        </button>
        <button
          onClick={onToggleTheme}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          className="btn-ghost"
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            {theme === 'dark' ? <FiSun aria-hidden /> : <FiMoon aria-hidden />}
            {theme === 'dark' ? 'Light' : 'Dark'}
          </span>
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FiUser aria-hidden />
          <span>{username}</span>
          <button
            onClick={() => onOpenSettings && onOpenSettings()}
            title="User settings"
            className="btn-ghost"
            style={{ padding: '4px 8px' }}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <FiSettings aria-hidden /> Settings
            </span>
          </button>
          <button
            onClick={onLogout}
            title="Logout"
            className="btn-ghost"
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <FiLogOut aria-hidden /> Logout
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
